module.exports = __webpack_public_path__ + "static/media/Hydroponics_types_img.bfe80694.webp";